import { render, staticRenderFns } from "./QueryList.vue?vue&type=template&id=52fcc329&"
import script from "./QueryList.vue?vue&type=script&lang=js&"
export * from "./QueryList.vue?vue&type=script&lang=js&"
import style0 from "./QueryList.vue?vue&type=style&index=0&id=52fcc329&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports